import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceContentsRegistScreenModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'checkbox',
        'screenConfigMstId',
        'screenConfigName',
        // 'screenOrientationKbn',
        'screenConfigStatus'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          screenConfigMstId: '画面構成ID',
          screenConfigName: '画面構成名',
          // screenOrientationKbn: '画面方向',
          screenConfigStatus: 'ステータス'
        },
        columnsClasses: {
          checkbox: 'wp-3',
          screenConfigMstId: 'wp-5',
          screenConfigName: '',
          // screenOrientationKbn: '',
          screenConfigStatus: ''
        },
        sortable: [
          'screenConfigMstId',
          'screenConfigName',
          // 'screenOrientationKbn',
          'screenConfigStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('画面'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceContentsRegistScreenModal.active,
      serviceId: state => state.serviceContentsRegistScreenModal.serviceId,
      serviceContentsId: state => state.serviceContentsRegistScreenModal.serviceContentsId,
      deviceTypeId: state => state.serviceContentsRegistScreenModal.deviceTypeId,

      // model
      screenModel: state => state.serviceContentsRegistScreenModal.screenModel,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    disableConfirmButton () {
      return this.checkList.length === 0
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'select') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceContentsRegistScreenModal/loadModel',
      hide: 'serviceContentsRegistScreenModal/hide',
      setUpdated: 'serviceContentsRegistScreenModal/setUpdated'
    }),

    init () {
      this.loading = true

      // データ更新フラグの初期化
      this.setUpdated(false)

      // // 選択済み連携CMSのIDをチェックリストに格納
      // if (this.deliveryTypeModel &&
      //   this.deliveryTypeModel.length) {
      //   this.checkList = $.extend(true, [], this.deliveryTypeModel.map(item => item.serviceDeliveryTypeUuid))
      // }

      //
      let screenConfigMstParams = {
        filters: {
          deviceTypeUuid: this.deviceTypeId
        }
      }
      console.log('screenConfigMstParams', screenConfigMstParams)

      // データ読出し
      this.loadModel({
        screenConfigMstParams: screenConfigMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.screenModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.screenConfigMstUuid
        // case 'screenOrientationKbn':
          // return Utility.getConstantsLabel(['Mst', 'ScreenOrientation'], value)
        case 'screenConfigStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    confirmData () {
      this.showConfirm({
        key: 'select',
        title: '画面構成の選択',
        body: 'この内容で情報を変更しますか？'
      })
    },
    postData () {
      console.log('check : ', this.checkList)

      this.processing = true

      let parameters = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId,
        request: {
          screenConfigMstUuids: this.checkList
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsScreenPost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '画面構成の登録',
              body: '「画面構成」を登録しました。'
            })

            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}